import Web3 from "web3";

import { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";

import LiquidityLockerCards from "./LiquidityLockerCards";
import LoadingBar from "../../../Components/UI/LoadingBar";

import ABI_StorageLaunchpad from "../../../abis/ABI_StorageLaunchpad.json";
import ABI_PRESALE from "../../../abis/ABI_Presale.json";
import ABI_LIQUIDITY_LOCK_PERSONAL from "../../../abis/presale/ABI_LIQUIDITY_LOCK_PERSONAL.json";

import {
    useIsMount,
    useRpcURL,
    useStorageContractAddress,
} from "../../../hooks";
import { getPresaleDetails } from "../../../utils/apis";
import { getTokenLink } from "../../../utils/constants";

const LiquidityLocker = () => {
    const isMount = useIsMount();

    const HTTP_RPC_URL = useRpcURL();
    const STORAGE_CONTRACT_ADDRESS = useStorageContractAddress();

    const [TokenLockersCardArray, setTokenLockersCardArray] = useState([]);
    const [loadingLockers, setLoadingLockers] = useState(true);

    useEffect(() => {
        const provider = new Web3(
            new Web3.providers.HttpProvider(HTTP_RPC_URL)
        );
        window.web3 = new Web3(provider);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [HTTP_RPC_URL]);

    useEffect(() => {
        // if (active)
        // console.log(isMount);
        if (isMount) loadTokenLockers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMount]);

    const loadTokenLockers = async () => {
        const _storageContract = new window.web3.eth.Contract(
            ABI_StorageLaunchpad,
            STORAGE_CONTRACT_ADDRESS
        );

        setLoadingLockers(true);

        const _totalProjects = parseInt(
            await _storageContract.methods.getProjectsCount().call()
        );
        let _lockersArray = [];
        let _counter = 0;

        // console.log(_totalProjects);
        await new Promise(function (resolve, reject) {
            for (let index = 0; index < _totalProjects; index++) {
                _storageContract.methods
                    .entryListByPresaleAddress(index)
                    .call()
                    // eslint-disable-next-line no-loop-func
                    .then(async (_presaleAddress) => {
                        const _presaleContract = new window.web3.eth.Contract(
                            ABI_PRESALE,
                            _presaleAddress
                        );

                        const [lockerLP, owner, tokenSymbol, offChainData] =
                            await Promise.all([
                                _presaleContract.methods.lockerLP().call(),
                                _presaleContract.methods.owner().call(),
                                _presaleContract.methods.tokenSymbol().call(),
                                getPresaleDetails(_presaleAddress),
                            ]);

                        if (parseInt(lockerLP) !== 0) {
                            const _lockerContract =
                                new window.web3.eth.Contract(
                                    ABI_LIQUIDITY_LOCK_PERSONAL,
                                    lockerLP
                                );

                            const [endOfLockTime] = await Promise.all([
                                _lockerContract.methods
                                    .LockedTimestamp()
                                    .call(),
                            ]);

                            _lockersArray.push({
                                lockerLP,
                                logo: getTokenLink(
                                    offChainData,
                                    "logo",
                                    "locker"
                                ),
                                name: `${tokenSymbol}-WBNB LP`,
                                owner,
                                endOfLockTime: new Date(
                                    endOfLockTime * 1000
                                ).toLocaleString(),
                                time: endOfLockTime,
                            });
                        }
                        _counter++;

                        if (_counter === parseInt(_totalProjects)) {
                            resolve();
                        }
                    });
            }
        });

        setLoadingLockers(false);
        setTokenLockersCardArray(_lockersArray);
    };
    return (
        <div className="flex flex-col main-container animation-fade-in relative">
            <h2 className="page-title">All LP Lockers</h2>
            <h5 className="page-subtitle">
                Lock your LP share and earn/withdraw rewards whilst locked
            </h5>

            <div className="relative flex items-center">
                <FiSearch className="absolute left-4" size={20} />
                <input
                    type="text"
                    className="rounded-lg text-[14px] p-3 pl-12 w-full"
                    placeholder="Search Lockers..."
                />
            </div>

            <div className="h-full flex flex-col pt-4">
                {loadingLockers && <LoadingBar />}
                <div className="grid grid-cols-1 md:grid-cols-3 2xl:grid-cols-4 w-full gap-x-8 gap-y-8 2xl:gap-x-8 2xl:gap-y-12">
                    {TokenLockersCardArray !== [] ? (
                        TokenLockersCardArray.map((el, i) => (
                            <LiquidityLockerCards {...el} key={i} />
                        ))
                    ) : (
                        <p>There is no Locked tokens</p>
                    )}
                </div>
            </div>
        </div>
    );
};
export default LiquidityLocker;
